<template>
  <form class=" mt-2 row g-3 align-items-baseline" v-if="model">
    <div class="form-group col-md-12">
      <span class="dx-field-item-label-text text-success">{{ $t("wizard.step4.direccion_suministro") }}</span>
    </div>
    <div class="form-group col-md-2">
      <label class="dx-field-item-label-text" for="inputCodPostal">{{ $t('operaciones.form.codigo_postal')
        }}</label>
      <div class="mt-1" id="inputCodPostal">{{ model?.Suministro.Direccion?.CodigoPostal }}</div>
    </div>
    <div class="form-group col-md-4">
      <label class="dx-field-item-label-text" for="inputProvincia">{{ $t('operaciones.form.provincia') }}</label>
      <div class="mt-1" id="inputProvincia">{{ model?.Suministro.Direccion?.Provincia }}</div>
    </div>
    <div class="form-group col-md-6">
      <label class="dx-field-item-label-text" for="inputMunicipio">{{ $t('operaciones.form.municipio') }}</label>
      <div class="mt-1" id="inputMunicipio">{{ model?.Suministro.Direccion?.Municipio }}</div>
    </div>
    <div class="form-group col-md-2">
      <label class="dx-field-item-label-text" for="inputTipoVia">{{ $t('operaciones.form.tipo_de_via') }}</label>
      <div class="mt-1" id="inputTipoVia">{{ model?.Suministro.Direccion?.TipoVia }}</div>
    </div>
    <div class="form-group col-md-6">
      <label class="dx-field-item-label-text" for="inputNombreVia">{{ $t('operaciones.form.nombre_de_via')
        }}</label>
      <div class="mt-1" id="inputNombreVia">{{ model?.Suministro.Direccion?.NombreVia }}</div>
    </div>
    <div class="form-group col-md-1">
      <label class="dx-field-item-label-text" for="inputNumero">{{ $t('operaciones.form.numero') }}</label>
      <div class="mt-1" id="inputNumero">{{ model?.Suministro.Direccion?.Numero }}</div>
    </div>
    <div class="form-group col-md-1">
      <label class="dx-field-item-label-text" for="inputEscalera">{{ $t('operaciones.form.escalera') }}</label>
      <div class="mt-1" id="inputEscalera">{{ model?.Suministro.Direccion?.Escalera }}</div>
    </div>
    <div class="form-group col-md-1">
      <label class="dx-field-item-label-text" for="inputPiso">{{ $t('operaciones.form.piso') }}</label>
      <div class="mt-1" id="inputPiso">{{ model?.Suministro.Direccion?.Piso }}</div>
    </div>
    <div class="form-group col-md-1">
      <label class="dx-field-item-label-text" for="inputPuerta">{{ $t('operaciones.form.puerta') }}</label>
      <div class="mt-1" id="inputPuerta">{{ model?.Suministro.Direccion?.Puerta }}</div>
    </div>
    <div class="form-group col-md-4">
      <label class="dx-field-item-label-text" for="inputCNAE">{{ $t('operaciones.form.cnae') }}</label>
      <div class="mt-1" id="inputCNAE">{{ model?.Suministro.CNAE }}</div>
    </div>
    <div class="form-group col-md-4">
      <span class="dx-field-item-label-text">{{ $t('operaciones.form.facturaDigital') }}</span><br>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="rbFacturaDigitalSi" value="true"
          :checked="!!model?.Suministro.FacturaDigital" disabled>
        <label class="form-check-label pt-1" for="rbFacturaDigitalSi">{{ $t('shared.ui.buttons.yes') }}</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="rbFacturaDigitalNo" value="false"
          :checked="!model?.Suministro.FacturaDigital" disabled>
        <label class="form-check-label pt-1" for="rbFacturaDigitalNo">{{ $t('shared.ui.buttons.no') }}</label>
      </div>
    </div>

    <div v-if="model?.OrigenConocimientoCups" class="form-group col-md-12">
      <label class="dx-field-item-label-text" for="inputOrigenConocimientoCups">{{ $t('operaciones.form.origen_conocimiento_cups') }}</label>
      <div class="mt-1" id="inputOrigenConocimientoCups">{{ translateEnum(OrigenConocimientoCupsEnum, model.OrigenConocimientoCups) }}</div>
    </div>

    <!-- Direccion de correspondencia -->
    <template v-if="!model?.Titular.DireccionIgualSuministro">
      <div class="form-group col-md-12">
        <span class="dx-field-item-label-text text-success d-block mt-3">{{ $t("wizard.step4.direccion_correspondencia")
          }}</span>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputCorrespondenciaCodPostal">{{
          $t('operaciones.form.codigo_postal')
        }}</label>
        <div class="mt-1" id="inputCorrespondenciaCodPostal">{{
          model?.Titular.Direccion?.CodigoPostal }}
        </div>
      </div>
      <div class="form-group col-md-4">
        <label class="dx-field-item-label-text" for="inputCorrespondenciaProvincia">{{
          $t('operaciones.form.provincia')
        }}</label>
        <div class="mt-1" id="inputCorrespondenciaProvincia">{{
          model?.Titular.Direccion?.Provincia }}
        </div>
      </div>
      <div class="form-group col-md-6">
        <label class="dx-field-item-label-text" for="inputCorrespondenciaMunicipio">{{
          $t('operaciones.form.municipio')
        }}</label>
        <div class="mt-1" id="inputCorrespondenciaMunicipio">{{
          model?.Titular.Direccion?.Municipio }}
        </div>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputCorrespondenciaTipoVia">{{
          $t('operaciones.form.tipo_de_via')
        }}</label>
        <div class="mt-1" id="inputCorrespondenciaTipoVia">{{
          model?.Titular.Direccion?.TipoVia }}</div>
      </div>
      <div class="form-group col-md-6">
        <label class="dx-field-item-label-text" for="inputCorrespondenciaNombreVia">{{
          $t('operaciones.form.nombre_de_via')
        }}</label>
        <div class="mt-1" id="inputCorrespondenciaNombreVia">{{
          model?.Titular.Direccion?.NombreVia }}
        </div>
      </div>
      <div class="form-group col-md-1">
        <label class="dx-field-item-label-text" for="inputCorrespondenciaNumero">{{ $t('operaciones.form.numero')
          }}</label>
        <div class="mt-1" id="inputCorrespondenciaNumero">{{
          model?.Titular.Direccion?.Numero }}</div>
      </div>
      <div class="form-group col-md-1">
        <label class="dx-field-item-label-text" for="inputCorrespondenciaEscalera">{{
          $t('operaciones.form.escalera') }}</label>
        <div class="mt-1" id="inputCorrespondenciaEscalera">{{
          model?.Titular.Direccion?.Escalera }}
        </div>
      </div>
      <div class="form-group col-md-1">
        <label class="dx-field-item-label-text" for="inputCorrespondenciaPiso">{{ $t('operaciones.form.piso')
          }}</label>
        <div class="mt-1" id="inputCorrespondenciaPiso">{{ model?.Titular.Direccion?.Piso
          }}</div>
      </div>
      <div class="form-group col-md-1">
        <label class="dx-field-item-label-text" for="inputCorrespondenciaPuerta">{{ $t('operaciones.form.puerta')
          }}</label>
        <div class="mt-1" id="inputCorrespondenciaPuerta">{{
          model?.Titular.Direccion?.Puerta }}</div>
      </div>
    </template>

    <!-- Seccion 3 -->

    <!-- Datos de suministro de luz -->
    <template v-if="mostrarLuz">
      <div class="form-group col-md-12">
        <span class="dx-field-item-label-text text-success mt-3 d-block">{{ $t("wizard.step4.datos_suministro_luz")
          }}</span>
      </div>
      <div class="form-group col-md-3">
        <label class="dx-field-item-label-text" for="inputLuzCUPS">{{ $t('operaciones.form.cups') }}</label>
        <div class="mt-1" id="inputLuzCUPS">{{ model?.TramiteLuz?.CUPS }}</div>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzTension">{{ $t('operaciones.form.tension') }}</label>
        <div class="mt-1" id="inputLuzTension">{{ model?.TramiteLuz?.Tension }}</div>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzTarifaAcceso">{{ $t('operaciones.form.tarifa_de_acceso')
          }}</label>
        <div class="mt-1" id="inputLuzTarifaAcceso">{{ model?.TramiteLuz?.TarifaAcceso }}</div>
      </div>
      <div class="form-group col-md-2">
        <span class="dx-field-item-label-text">{{ $t('operaciones.form.altaSuministroLuz') }}</span><br>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbAltaLuzSi" value="true"
            :checked="!model?.TramiteLuz?.Alta" disabled>
          <label class="form-check-label pt-1" for="rbAltaLuzSi">{{ $t('shared.ui.buttons.yes') }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbAltaLuzNo" value="false"
            :checked="!!model?.TramiteLuz?.Alta" disabled>
          <label class="form-check-label pt-1" for="rbAltaLuzNo">{{ $t('shared.ui.buttons.no') }}</label>
        </div>
      </div>
      <div class="form-group col-md-2">
        <span class="dx-field-item-label-text">{{ $t('operaciones.form.conexionPrevia') }}</span><br>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbConexionPreviaLuzSi" value="true"
            :checked="!!model?.TramiteLuz?.ConexionPrevia" disabled>
          <label class="form-check-label pt-1" for="rbConexionPreviaLuzSi">{{ $t('shared.ui.buttons.yes') }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbConexionPreviaLuzNo" value="false"
            :checked="!model?.TramiteLuz?.ConexionPrevia" disabled>
          <label class="form-check-label pt-1" for="rbConexionPreviaLuzNo">{{ $t('shared.ui.buttons.no') }}</label>
        </div>
      </div>
      
      <div class="form-group col-md-12" v-if="model?.TramiteLuz?.Alta == false">
        <span class="dx-field-item-label-text">{{ $t('operaciones.form.cual_es_su_compania_actual') }}</span><br>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbCompaniaActualLuzMisma" value="true"
            :checked="!model?.TramiteLuz?.DistintaComercializadoraMismoGrupo &&
            model?.TramiteLuz?.ComercializadoraAnterior == null" disabled>
          <label class="form-check-label pt-1" for="rbCompaniaActualLuzMisma">{{ $t('operaciones.form.misma_compania') }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbCompaniaActualLuzDistintaMismoGrupo" value="false"
            :checked="model?.TramiteLuz?.DistintaComercializadoraMismoGrupo == true" disabled>
          <label class="form-check-label pt-1" for="rbCompaniaActualLuzDistintaMismoGrupo">{{ $t('operaciones.form.distinta_mismo_grupo') }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbCompaniaActualLuzOtra" value="false"
            :checked="model?.TramiteLuz?.ComercializadoraAnterior != null" disabled>
          <label class="form-check-label pt-1" for="rbCompaniaActualLuzOtra">{{ $t('operaciones.form.otra_compania') }}</label>
        </div>
      </div>
      <div class="form-group col-md-2" v-if="model?.TramiteLuz?.ComercializadoraAnterior != null">
        <label class="dx-field-item-label-text" for="inputLuzCompaniaAnterior">{{
          $t('operaciones.form.compania_anterior') }}</label>
        <div class="mt-1" id="inputLuzCompaniaAnterior">{{ model?.TramiteLuz?.ComercializadoraAnterior }}</div>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzConsumo">{{
          $t('operaciones.form.consumo') }}</label>
        <div class="mt-1" id="inputLuzConsumo">{{ model?.TramiteLuz?.Consumo }} <span v-if="model?.TramiteLuz?.Consumo">kWh</span>
        </div>
      </div>
      <div v-if="model?.TramiteLuzFechaActivacion" class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzFechaAlta">{{
          $t('operaciones.form.fecha_alta') }}</label>
        <div class="mt-1" id="inputLuzFechaAlta">{{ new Date(model?.TramiteLuzFechaActivacion).toLocaleDateString() }}</div> 
      </div>
      <div v-if="model?.TramiteLuzFechaBaja" class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzFechaBaja">{{
          $t('operaciones.form.fecha_baja') }}</label>
        <div class="mt-1" id="inputLuzFechaBaja">{{ new Date(model?.TramiteLuzFechaBaja).toLocaleDateString() }}</div> 
      </div>
      <div class="form-group col-md-7"></div>
      <div>
        <span class="dx-field-item-label-text">{{ $t('operaciones.form.potencia_actual_contratada') }}</span>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzPotencia1">{{ $t('operaciones.form.potencia') }} 1</label>
        <div class="mt-1" id="inputLuzPotencia1">{{ model?.TramiteLuz?.P1 }} <span v-if="model?.TramiteLuz?.P1">kW</span></div>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzPotencia2">{{ $t('operaciones.form.potencia') }} 2</label>
        <div class="mt-1" id="inputLuzPotencia2">{{ model?.TramiteLuz?.P2 }} <span v-if="model?.TramiteLuz?.P2">kW</span></div>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzPotencia3">{{ $t('operaciones.form.potencia') }} 3</label>
        <div class="mt-1" id="inputLuzPotencia3">{{ model?.TramiteLuz?.P3 }} <span v-if="model?.TramiteLuz?.P3">kW</span></div>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzPotencia4">{{ $t('operaciones.form.potencia') }} 4</label>
        <div class="mt-1" id="inputLuzPotencia4">{{ model?.TramiteLuz?.P4 }} <span v-if="model?.TramiteLuz?.P4">kW</span></div>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzPotencia5">{{ $t('operaciones.form.potencia') }} 5</label>
        <div class="mt-1" id="inputLuzPotencia5">{{ model?.TramiteLuz?.P5 }} <span v-if="model?.TramiteLuz?.P5">kW</span></div>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzPotencia6">{{ $t('operaciones.form.potencia') }} 6</label>
        <div class="mt-1" id="inputLuzPotencia6">{{ model?.TramiteLuz?.P6 }} <span v-if="model?.TramiteLuz?.P6">kW</span></div>
      </div>
      
      <div class="form-group col-md-2">
        <span class="dx-field-item-label-text">{{ $t('operaciones.form.cambioPotenciaContratada') }}</span><br>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbCambioPotenciaContratadaSi" value="true"
            :checked="!!model?.TramiteLuz?.CambioPotenciaContratada" disabled>
          <label class="form-check-label pt-1" for="rbCambioPotenciaContratadaSi">{{ $t('shared.ui.buttons.yes') }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbCambioPotenciaContratadaNo" value="false"
            :checked="!model?.TramiteLuz?.CambioPotenciaContratada" disabled>
          <label class="form-check-label pt-1" for="rbCambioPotenciaContratadaNo">{{ $t('shared.ui.buttons.no') }}</label>
        </div>
      </div>
      <div v-if="model?.TramiteLuz?.CambioPotenciaContratada">
        <span class="dx-field-item-label-text">{{ $t('operaciones.form.potencia_nueva_a_contratar') }}</span>
      </div>
      <div v-if="model?.TramiteLuz?.CambioPotenciaContratada" class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzPotencia1">{{ $t('operaciones.form.potencia') }} 1</label>
        <div class="mt-1" id="inputLuzPotenciaNueva1">{{ model?.TramiteLuz?.P1_Nueva }} <span v-if="model?.TramiteLuz?.P1_Nueva">kW</span></div>
      </div>
      <div v-if="model?.TramiteLuz?.CambioPotenciaContratada" class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzPotencia2">{{ $t('operaciones.form.potencia') }} 2</label>
        <div class="mt-1" id="inputLuzPotenciaNueva2">{{ model?.TramiteLuz?.P2_Nueva }} <span v-if="model?.TramiteLuz?.P2_Nueva">kW</span></div>
      </div>
      <div v-if="model?.TramiteLuz?.CambioPotenciaContratada" class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzPotencia3">{{ $t('operaciones.form.potencia') }} 3</label>
        <div class="mt-1" id="inputLuzPotenciaNueva3">{{ model?.TramiteLuz?.P3_Nueva }} <span v-if="model?.TramiteLuz?.P3_Nueva">kW</span></div>
      </div>
      <div v-if="model?.TramiteLuz?.CambioPotenciaContratada" class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzPotencia4">{{ $t('operaciones.form.potencia') }} 4</label>
        <div class="mt-1" id="inputLuzPotenciaNueva4">{{ model?.TramiteLuz?.P4_Nueva }} <span v-if="model?.TramiteLuz?.P4_Nueva">kW</span></div>
      </div>
      <div v-if="model?.TramiteLuz?.CambioPotenciaContratada" class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzPotencia5">{{ $t('operaciones.form.potencia') }} 5</label>
        <div class="mt-1" id="inputLuzPotenciaNueva5">{{ model?.TramiteLuz?.P5_Nueva }} <span v-if="model?.TramiteLuz?.P5_Nueva">kW</span></div>
      </div>
      <div v-if="model?.TramiteLuz?.CambioPotenciaContratada" class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputLuzPotencia6">{{ $t('operaciones.form.potencia') }} 6</label>
        <div class="mt-1" id="inputLuzPotenciaNueva6">{{ model?.TramiteLuz?.P6_Nueva }} <span v-if="model?.TramiteLuz?.P6_Nueva">kW</span></div>
      </div>  
    </template>

    <!-- Datos de suministro de gas -->
    <template v-if="mostrarGas">
      <div class="form-group col-md-12">
        <span class="dx-field-item-label-text text-success mt-3 d-block">{{ $t("wizard.step4.datos_suministro_gas")
          }}</span>
      </div>
      <div class="form-group col-md-3">
        <label class="dx-field-item-label-text" for="inputGasCUPS">{{ $t('operaciones.form.cups') }}</label>
        <div class="mt-1" id="inputGasCUPS">{{ model?.TramiteGas?.CUPS }}</div>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputGasTarifaAcceso">{{ $t('operaciones.form.tarifa_de_acceso')
          }}</label>
        <div class="mt-1" id="inputGasTarifaAcceso">{{ model?.TramiteGas?.TarifaAcceso }}</div>
      </div>
      <div class="form-group col-md-2">
        <span class="dx-field-item-label-text">{{ $t('operaciones.form.altaSuministroGas') }}</span><br>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbAltaGasSi" value="true"
            :checked="!model?.TramiteGas?.Alta" disabled>
          <label class="form-check-label pt-1" for="rbAltaGasSi">{{ $t('shared.ui.buttons.yes') }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbAltaGasNo" value="false"
            :checked="!!model?.TramiteGas?.Alta" disabled>
          <label class="form-check-label pt-1" for="rbAltaGasNo">{{ $t('shared.ui.buttons.no') }}</label>
        </div>
      </div>
      <div class="form-group col-md-2">
        <span class="dx-field-item-label-text">{{ $t('operaciones.form.conexionPrevia') }}</span><br>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbConexionPreviaGasSi" value="true"
            :checked="!!model?.TramiteGas?.ConexionPrevia" disabled>
          <label class="form-check-label pt-1" for="rbConexionPreviaGasSi">{{ $t('shared.ui.buttons.yes') }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbConexionPreviaGasNo" value="false"
            :checked="!model?.TramiteGas?.ConexionPrevia" disabled>
          <label class="form-check-label pt-1" for="rbConexionPreviaGasNo">{{ $t('shared.ui.buttons.no') }}</label>
        </div>
      </div>
      <div class="form-group col-md-2">
      </div>
      
      <div class="form-group col-md-12" v-if="model?.TramiteGas?.Alta == false">
        <span class="dx-field-item-label-text">{{ $t('operaciones.form.cual_es_su_compania_actual') }}</span><br>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbCompaniaActualGasMisma" value="true"
            :checked="!model?.TramiteGas?.DistintaComercializadoraMismoGrupo &&
            model?.TramiteGas?.ComercializadoraAnterior == null" disabled>
          <label class="form-check-label pt-1" for="rbCompaniaActualGasMisma">{{ $t('operaciones.form.misma_compania') }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbCompaniaActualGasDistintaMismoGrupo" value="false"
            :checked="model?.TramiteGas?.DistintaComercializadoraMismoGrupo == true" disabled>
          <label class="form-check-label pt-1" for="rbCompaniaActualGasDistintaMismoGrupo">{{ $t('operaciones.form.distinta_mismo_grupo') }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" id="rbCompaniaActualGasOtra" value="false"
            :checked="model?.TramiteGas?.ComercializadoraAnterior != null" disabled>
          <label class="form-check-label pt-1" for="rbCompaniaActualGasOtra">{{ $t('operaciones.form.otra_compania') }}</label>
        </div>
      </div>
      <div class="form-group col-md-3" v-if="model?.TramiteGas?.ComercializadoraAnterior != null">
        <label class="dx-field-item-label-text" for="inputGasCompaniaAnterior">{{
          $t('operaciones.form.compania_anterior') }}</label>
        <div class="mt-1" id="inputGasCompaniaAnterior">{{ model?.TramiteGas?.ComercializadoraAnterior }}
        </div>
      </div>
      <div class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputGasConsumo">{{
          $t('operaciones.form.consumo') }}</label>
        <div class="mt-1" id="inputGasConsumo">{{ model?.TramiteGas?.Consumo }} <span v-if="model?.TramiteGas?.Consumo">kWh</span>
        </div>
      </div>
      <div v-if="model?.TramiteGasFechaActivacion" class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputGasFechaAlta">{{
          $t('operaciones.form.fecha_alta') }}</label>
        <div class="mt-1" id="inputGasFechaAlta">{{ new Date(model?.TramiteGasFechaActivacion).toLocaleDateString() }}</div> 
      </div>
      <div v-if="model?.TramiteGasFechaBaja" class="form-group col-md-2">
        <label class="dx-field-item-label-text" for="inputGasFechaBaja">{{
          $t('operaciones.form.fecha_baja') }}</label>
        <div class="mt-1" id="inputGasFechaBaja">{{ new Date(model?.TramiteGasFechaBaja).toLocaleDateString() }}</div> 
      </div>
      <div class="form-group col-md-7"></div>
    </template>
  </form>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { type DetailOperacionEnergiaModel, OrigenConocimientoCupsEnum, TipoSuministroTramiteEnergiaEnum } from '@/.shared/.api';
import { translateEnum } from '@helpers/enums-helper';
import { TipoEnergiaSeleccionadaEnum } from '@/components/nueva-venta/models/TipoEnergiaSeleccionadaEnum';

const props = defineProps({
  model: Object as () => DetailOperacionEnergiaModel,
  tramite: String as () => TipoSuministroTramiteEnergiaEnum
});

const mostrarLuz = computed(() => {
  return props.tramite == TipoEnergiaSeleccionadaEnum.Luz || (props.tramite == null && props.model?.TramiteLuz != null);
});

const mostrarGas = computed(() => {
  return props.tramite == TipoEnergiaSeleccionadaEnum.Gas || (props.tramite == null && props.model?.TramiteGas != null);
});

</script>

<style lang="scss" scoped>

@import "@styles/_sharedvars.scss";

div[id^="input"] {
  border-bottom: 1px solid var(--border-default-default);
  padding: 5px 12px;
  background: var(--background-normal-light);
  color: var(--text-default-caption);
  height: 30px;
}

.dx-field-item-label-text {
  white-space: nowrap;
  word-wrap: normal;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>